module.exports = __webpack_public_path__ + "img/2. People Centred Care.005a9d4a.png";